import type { paths } from '@luxuryescapes/contract-customer-communication';

import { json_headers, request } from '~/services/common';

import { makeCustomerCommunicationV2URL } from './customerCommunicationRequestUtils';

type RemoveFromListType =
  paths['/api/customer-communication/v2/subscriptions/users/{userId}/status']['patch']['requestBody']['content']['application/json']['removeFromList'];

async function requestPatchEmailDeliveryStatus(userId: string, brand: string, type: RemoveFromListType) {
  if (!userId) {
    throw 'missing userId';
  }
  if (!brand) {
    throw 'missing brand';
  }

  const url = makeCustomerCommunicationV2URL(`/subscriptions/users/${userId}/status?brand=${brand}`);

  return request(url.toString(), {
    method: 'PATCH',
    credentials: 'include',
    headers: json_headers,
    body: JSON.stringify({ removeFromList: type }),
  }).catch((error) => {
    throw JSON.stringify(error, null, 2);
  });
}

export default requestPatchEmailDeliveryStatus;
